import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

import { QUERY_CACHE_DEFAULT_EXPIRATION_MS, SWITCHES_QUERY_KEY } from "@config/query";
import { SWITCHES } from "@config/constants";
import userService from "@services/user.service";

export interface ISwitch {
  active: boolean;
  name: string;
  note: string;
}

export type AVAILABLE_SWITCHES = keyof typeof SWITCHES;
export type isAvailableFunction = (key: AVAILABLE_SWITCHES) => boolean;

export function useSwitches() {
  const query = useQuery({
    queryKey: [SWITCHES_QUERY_KEY],
    queryFn: async () => {
      return await userService.getFeatureSwitches();
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
  });

  const isAvailable: isAvailableFunction = useCallback(
    (key: AVAILABLE_SWITCHES) => {
      return query.data?.find((flag) => flag.name === SWITCHES[key])?.active ?? false;
    },
    [query.data]
  );

  return {
    isAvailable,
    data: query.data,
    featureFlagsFetched: query.isFetched,
  };
}
